import { Tabs } from "antd";
import React, { Component } from "react";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import StaticClass from "../../../utils/staticClass";
// import
export default class SearchResult500 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "DuAn",
      dataSuDungDat: [],
    };

    this.listDuAnTitle = [
      "Mã dự án",
      "Quận/Huyện",
      "Phường/Xã",
      "Tên dự án",
      "Diện tích (ha)",
      "Chủ đầu tư",
      "Điều hành dự án",
      "Tiến độ",
      "Quyết định pháp lý",
      "Năm ra quyết định",
      "Ghi chú",
      "Năm quy hoạch",
    ];

    this.listDuAnValue = [
      "Madoan",
      "TENHUYEN",
      "TenPhuong",
      "Tendoan",
      "DienTich",
      "Chudautu",
      "Dieuhanhduan",
      "TinhTrang",
      "Quyetdinhphaply",
      "NamraQDphaply",
      "GhiChu",
      "NamQH",
    ];

    this.listTienDo = [
      {
        value: 0,
        name: "-",
      },
      {
        value: 1,
        name: "Cơ bản hoàn thành",
      },

      {
        value: 2,
        name: "Đang triển khai",
      },

      {
        value: 3,
        name: "Chưa triển khai",
      },

      {
        value: 4,
        name: "Chậm triển khai",
      },
    ];
  }

  componentDidMount() {
    this.getDataSuDungDat();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.getDataSuDungDat();
    }
  }

  changeTab(e) {
    this.setState({
      activeTab: e,
    });
  }

  async getDataSuDungDat() {
    if (this.props.data && this.props.data.OBJECTID_1) {
      let res = await AxiosGetSecretApi(
        `/api/duanqh/danhsach-sd-dat?id=${this.props.data.OBJECTID_1}`
      );
      if (res && Array.isArray(res) && res.length !== 0) {
        this.setState({
          dataSuDungDat: res,
        });
      } else {
        this.setState({
          dataSuDungDat: [],
        });
      }
    }
  }

  render() {
    const dataTable = this.state.dataSuDungDat.map((o, i) => {
      return (
        <tr key={i}>
          <td
            style={{ width: "40px", display: "flex", justifyContent: "center" }}
          >
            {i + 1}
          </td>
          <td style={{ width: "125px", textAlign: "left" }}>{o.LoaiDat}</td>
          <td style={{ width: "83px", textAlign: "left" }}>{StaticClass.formatPrice(o.DienTich)}</td>
          <td style={{ width: "55px", textAlign: "center" }}>{StaticClass.formatPrice(o.TyLe)}</td>
        </tr>
      );
    });

    return (
      <div className="search-500">
        <div className="search-500-header">
          Thông tin dự án quy hoạch 1/500
          <i className="fas fa-times close-icon" onClick={this.props.close}></i>
        </div>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane
            key="1"
            tab={
              <div style={{ width: "154px", textAlign: "center" }}>Dự án</div>
            }
          >
            <div className="search-500-body">
              <div>
                {this.listDuAnTitle.map((e, i) => (
                  <div style={{ display: "flex" }} key={i}>
                    <div className="col-left search-500-text" style={{marginRight: 0 }} >
                      {e}:
                    </div>

                    <div className="col-right search-500-text-gray" style={{maxWidth: 185}}>
                      {this.props.data[`${this.listDuAnValue[i]}`] &&
                      this.props.data[`${this.listDuAnValue[i]}`] !== "null" &&
                      this.props.data[`${this.listDuAnValue[i]}`] !== "Null"
                        ? i === 7
                          ? Number.isInteger(
                              this.props.data[`${this.listDuAnValue[i]}`]
                            )
                            ? this.listTienDo[
                                this.props.data[`${this.listDuAnValue[i]}`]
                              ].name
                            : "-"
                          : i === 4
                              ? StaticClass.formatPrice(this.props.data[`${this.listDuAnValue[i]}`])
                              : this.props.data[`${this.listDuAnValue[i]}`]
                          
                        : "-"}
                    </div>
                  </div>
                ))}

                {this.props.file && Array.isArray(this.props.file) && this.props.file.length !== 0 && (
                  <div style={{ display: "flex" }}>
                    <div className="col-left search-500-text" style={{marginRight: 0 }}>
                      File đính kèm:
                    </div>
                    <div>
                      {this.props.file.map((e, i) => (
                        <div
                          className="col-right search-500-text"
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "125px",
                            color: "#1e86eb",
                            cursor: "pointer",
                            maxWidth: 185
                          }}
                          onClick = {async()=>{
                            const response = await AxiosGetSecretApi(`/api/otp-token`);
                            window.open(`${e.Duongdanfiledinhkem}?key=${response.token}`, "_blank")
                          }}
                        >
                          {e.Tenfiledinhkem}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane
            key="2"
            tab={
              <div style={{ width: "154px", textAlign: "center" }}>
                Chi tiết sử dụng đất
              </div>
            }
          >
            <div className="search-500-body">
              <div>
                {this.state.dataSuDungDat.length !== 0 ? (
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <th style={{ width: "40px", textAlign: "center" }}>
                            STT
                          </th>
                          <th style={{ width: "125px", textAlign: "center" }}>
                            Loại đất
                          </th>
                          <th style={{ width: "90px", textAlign: "center" }}>
                            Diện tích (m²)
                          </th>
                          <th style={{ width: "50px", textAlign: "center" }}>
                            {" "}
                            Tỷ lệ (%)
                          </th>
                        </tr>
                        {dataTable}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>Chưa có thông tin</div>
                )}
              </div>
            </div>
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}
